import React, { useEffect } from "react";
import { useUnit } from "effector-react";
import {
  setPage,
  setSelectedWashing,
  setFinalPrice,
  WashingStore,
} from "../../../../stores/WashingStore/WashingStore";
import { PAGES } from "../../../../stores/WashingStore/WashingStore.types";
import TotemButton from "../../components/TotemButton/TotemButton";
import TotemOption from "../../components/TotemOption/TotemOption";

import { fetchWashingMachinesEffect } from "../../../../stores/WashingStore/WashingStore.effects";
import { UserStore } from "../../../../stores/UserStore/UserStore";
import {
  NoWashings,
  WashingsContainer,
  NoStation,
} from "./ChooseWashingStyles";
import TotemSkeleton from "../../components/TotemSkeleton/TotemSkeleton";
import { setLoading } from "../../../../stores/MainStore/MainStore";
import { WashingOption } from "../../../../types/washing.types";
import { Colors } from "../../../../constants/Colors";

interface BtnsProps {
  selected?: WashingOption;
  handleNextStep: () => void;
  handleGoBack: () => void;
}

const Buttons = ({ selected, handleNextStep, handleGoBack }: BtnsProps) => {
  const text = selected?.name ? "Continuar" : "Selecione uma opção";

  return (
    <>
      <TotemButton negative onClick={() => handleGoBack()} text="Voltar" />
      <TotemButton
        disabled={!selected?.name}
        onClick={() => handleNextStep()}
        text={text}
      />
    </>
  );
};

const ChooseWashing: React.FC = () => {
  const { washingOptions, selectedWashing } = useUnit(WashingStore);
  const { station } = useUnit(UserStore);

  useEffect(() => {
    if (selectedWashing) {
      setFinalPrice(selectedWashing.price);
    }
  }, [selectedWashing]);

  useEffect(() => {
    handleGetWashings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGetWashings = () => {
    if (!station) {
      return;
    }

    setLoading(true);

    fetchWashingMachinesEffect(station).finally(() => {
      setLoading(false);
    });
  };

  const handleNextStep = () => {
    setPage(PAGES.WASHING_PAYMENT);
  };

  const handleGoBack = () => {
    setPage(PAGES.CHOOSE_LICENCE);
  };

  const renderSection = (title: string, washings: WashingOption[]) => {
    if (!washings.length) return null;

    return (
      <div style={{ marginBottom: "3rem" }}>
        <h2
          style={{
            fontSize: "2rem",
            marginBottom: "1.5rem",
            textAlign: "center",
            color: Colors.commons.black,
            fontStyle: "italic",
          }}
        >
          {title}
        </h2>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: "1.5rem",
          }}
        >
          {washings.map((washing) => {
            const isselected = selectedWashing?.id === washing.id;
            const fixedPrice = washing?.price?.toFixed(2).replace(".", ",");
            const priceText = `R$ ${fixedPrice ?? "ERRO"}`;
            
            return (
              <TotemOption
                key={washing.id}
                title={washing?.name}
                subtitle={priceText}
                isselected={isselected}
                execSelection={() => setSelectedWashing(washing)}
              />
            );
          })}
        </div>
      </div>
    );
  };

  const renderWashings = () => {
    if (!station) {
      return (
        <NoStation>
          <p>Usuário sem estação, procure um atendente!</p>
        </NoStation>
      );
    }

    if (!washingOptions?.length)
      return (
        <NoWashings onClick={handleGetWashings}>
          <p>Nenhum tipo de lavação encontrado.</p>
          <p>Clique aqui para tentar novamente</p>
          <p> ou solicite ajuda a um atendente</p>
        </NoWashings>
      );

    // separando em seções
    const carWashings = washingOptions.filter((w) => w.type === "CAR");
    const vanWashings = washingOptions.filter((w) => w.type === "VAN");

    return (
      <>
        {renderSection("Carros", carWashings)}
        {renderSection("Vans", vanWashings)}
      </>
    );
  };

  return (
    <TotemSkeleton
      title="Escolha o Tipo de Lavação"
      buttons={
        <Buttons
          selected={selectedWashing}
          handleNextStep={handleNextStep}
          handleGoBack={handleGoBack}
        />
      }
    >
      <WashingsContainer>{renderWashings()}</WashingsContainer>
    </TotemSkeleton>
  );
};

export default ChooseWashing;
